import React from "react";
import styles from "../../../styles/home/Components/FellowshipSection.module.css";
import { FiCalendar } from "react-icons/fi";

const events = [
  {
    day: "SUNDAY",
    title: "Sunday Services",
    services: [
      { name: "First Service", time: "08:00 - 10:00" },
      { name: "Second Service", time: "10:30 - 12:30" },
      { name: "Prophetic Service", time: "03:30 - 20:00" },
    ],
  },
  {
    day: "WEDNESDAY",
    title: "Kingdom Advancement Service",
    services: [{ name: "", time: "17:00 - 20:00" }],
  },
  {
    day: "FRIDAY",
    title: "Empowerment Service",
    services: [{ name: "", time: "17:30 - 20:00" }],
  },
];

export default function FellowshipSection() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Left: Invitation */}
        <div className={styles.invite}>
          <div className={styles.badge}>
            <svg className={styles.badgeIcon} fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z" />
            </svg>
            <span className={styles.badgeText}>A Warm Invitation</span>
          </div>
          <h2 className={styles.title}>
            Join us in <span className={styles.highlight}>fellowship</span>
          </h2>
          <p className={styles.desc}>
            Whether you're seeking a midweek spiritual boost or a Sunday filled
            with praise and worship, our doors are open to all. Come and be a
            part of our vibrant church family as we grow in faith and love
            together.
          </p>
          <a href="/fellowship" className={styles.link}>
            <span>Find a location near you</span>
            <svg className={styles.linkIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </a>
        </div>

        {/* Right: Events */}
        <div className={styles.events}>
          <div className={styles.timeline}>
            {events.map((event, idx) => (
              <div className={styles.eventRow} key={idx}>
                <div className={styles.iconCol}>
                  <div className={styles.iconWrap}>
                    <FiCalendar className={styles.icon} />
                  </div>
                  {idx < events.length - 1 && (
                    <div className={styles.vertLine}></div>
                  )}
                </div>
                <div className={styles.eventContent}>
                  <div className={styles.eventDay}>{event.day}</div>
                  <div className={styles.eventTitle}>{event.title}</div>
                  <div className={styles.servicesList}>
                    {event.services.map((s, i) => (
                      <div key={i} className={styles.serviceItem}>
                        {s.name && (
                          <span className={styles.serviceName}>{s.name}</span>
                        )}
                        <span className={styles.serviceTime}>{s.time}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}